import React, { useState } from 'react';
import { Typography, Stack, Button, CircularProgress, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useSession } from '@platform/core/src/context/SessionContext';
import appConfig from '../../appConfig';

const OnboardingCompleteMessage = () => {
  const { initializeSession } = useSession();
  const [isProceeding, setIsProceeding] = useState(false);

  const handleContinue = async () => {
    setIsProceeding(true);
    
    try {
      // 1. We attempt to go to the default "Main Experience" (Coach Chat).
      // 2. The useOnboardingLock hook will detect this team change.
      // 3. It will check your Legal Status. 
      // 4. If Legal is not signed, it will immediately redirect to 'legal_team'.
      // 5. If Legal IS signed, it will let you through to the Coach.
      await initializeSession(null, {
        team_name: appConfig.defaultTeamName || 'welcome_group'
      });
      
      // Note: We don't set isProceeding(false) because the session will 
      // reload/redirect, unmounting this component.
    } catch (error) {
      console.error("Failed to proceed:", error);
      setIsProceeding(false);
    }
  };

  return (
    <Stack 
      spacing={3} 
      sx={{ 
        maxWidth: '100%', 
        alignItems: 'center', 
        py: 4, 
        px: 2,
        bgcolor: 'background.paper',
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider'
      }}
    >
      <CheckCircleIcon sx={{ fontSize: 64, color: 'success.main' }} />
      
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Profile Setup Complete!
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Your fitness profile has been saved successfully.
        </Typography>
      </Box>

      <Button 
        variant="contained" 
        size="large" 
        endIcon={isProceeding ? <CircularProgress size={20} color="inherit"/> : <ArrowForwardIcon />}
        onClick={handleContinue}
        disabled={isProceeding}
        sx={{ 
          minWidth: 200,
          py: 1.5,
          borderRadius: 2,
          fontWeight: 'bold'
        }}
      >
        {isProceeding ? 'Loading...' : 'Continue'}
      </Button>
    </Stack>
  );
};

export default OnboardingCompleteMessage;